<template>
  <div>
    <AppPaginaBarraSuperior :items="items" :menu-lateral="true">
    </AppPaginaBarraSuperior>
    <AppPaginaTitulo
        titulo="Armazenamentos do Servidor"
        descricao="Edite os armazenamentos do servidor"
    />
    <div class="card m-3 shadow-sm">
      <div class="card-body">
        <ArmazenamentoTable />
      </div>
    </div>
  </div>
</template>
<script>
import AppPaginaBarraSuperior from "../components/layout/AppPaginaBarraSuperior.vue";
import AppPaginaTitulo from "../components/layout/AppPaginaTitulo.vue";

import ArmazenamentoTable from "../components/servidor/ArmazenamentoTable.vue";

export default {
  name: "armazenamento",
  components: {
    AppPaginaBarraSuperior,
    AppPaginaTitulo,
    ArmazenamentoTable
  },
  data() {
    return {
      items: [
        {
          text: "Armazenamentos",
          active: true
        }
      ]
    };
  }
};
</script>

<style lang="sass"></style>
